import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const Hero = () => {
  const { t } = useLanguage();

  return (
    <section className="min-h-screen bg-[#1A1612] flex items-center px-6 py-12">
      {/* SEO H1 - Visually hidden */}
      <h1 className="sr-only">Interior Design Studio Sofia & Milano | Element by Elena Mustakova</h1>
      
      <div className="max-w-7xl mx-auto w-full">
        <div className="grid md:grid-cols-2 gap-12 md:gap-16 items-center">
          {/* Left column - Direct Video (Smooth Playback) */}
          <div className="flex justify-center">
            <div 
              className="relative w-full max-w-[380px] mx-auto bg-[#1A1612]"
              style={{ aspectRatio: '9 / 16' }}
            >
              <video
                src="/videos/hero-video.mp4"
                className="absolute inset-0 w-full h-full object-cover"
                autoPlay
                loop
                muted
                playsInline
                preload="auto"
                style={{ border: 'none' }}
              />
            </div>
          </div>

          {/* Right column - Logo and tagline */}
          <div className="text-[#F6F4F1] flex flex-col justify-center space-y-12">
            <div>
              <img
                src="https://customer-assets.emergentagent.com/job_sophisticated-spaces-1/artifacts/tqgjb85d_element_logo_final_notext.png"
                alt="Element by Elena Mustakova - Interior Design Studio Sofia Milano"
                className="w-32 h-32 md:w-40 md:h-40 lg:w-48 lg:h-48"
                style={{ filter: 'brightness(0) invert(1)' }}
              />
            </div>

            <p className="text-2xl md:text-3xl lg:text-4xl font-light leading-relaxed">
              {t('home.tagline')}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
